import {
  Badge,
  MediaGroup,
  MediaWithViewer,
  Space,
  SubText,
} from '@procurify/ui'

import { APUnbilledItemTag } from '@webapp/components/APUnbilledItemTag'
import { useFormatMedia } from '@webapp/core/hooks/useFormatMedia'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const APItemDescriptionCell = ({
  attachments,
  description,
  sku,
  itemType,
}: ColumnTypeData['AP_ITEM_DESCRIPTION']) => {
  const intl = useProcurifyIntl()
  const formatMedia = useFormatMedia()

  return (
    <Space direction='horizontal'>
      {attachments?.[0]?.file && (
        <MediaGroup>
          <MediaWithViewer
            src={formatMedia(attachments[0].file)}
            files={attachments.map((att) => ({
              file: formatMedia(att.file),
              name: att.name,
            }))}
            onClick={(e) => e.stopPropagation()}
          />
          {attachments.length > 1 && <Badge>{attachments.length}</Badge>}
        </MediaGroup>
      )}

      <Space direction='vertical' size='xsmall'>
        <SubText inline bold>
          {description}
        </SubText>
        {sku && (
          <SubText inline bold autoMargin={false}>
            {intl.formatMessage(messages.skuLabel, { sku })}
          </SubText>
        )}
        {itemType && <APUnbilledItemTag itemType={itemType} />}
      </Space>
    </Space>
  )
}

APItemDescriptionCell.displayName = 'APItemDescriptionCell'
